<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">提醒和提醒</a></li>
                <li><a href="#">提醒类型管理</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>提醒类型管理</span></div>
    
            <ul class="forminfo">
            
                <li style="padding-top:15px;" v-for="item in tixingtypeList">
                    <div class="groupings_l">{{item.txtypename}}</div>
                    <div class="groupings_l">
                        <a href="#" @click="editTxType(item.id,item.txtypename)">编辑</a> &nbsp;&nbsp;  <!--<a href="#" @click="delTxType(item.id)">删除</a>-->
                    </div>
                </li>
                <div class="xline"></div>
    
                <li style="padding-top:15px;">
                    <div class="groupings_l"> &nbsp; </div>
                    <div class="groupings_l">
                    
                        <ul class="toolbars">
                            <li class="click" @click="addTxGroup()">添加分组</li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>

        <!---->
        <div class="tip">
    	    <div class="tiptop"><span>提示信息</span><a></a></div>
        
            <div class="tipinfo">
                <input v-show="false" v-model="txtypeId"  />
                提醒名称：<input name="" v-model="txtypename" type="text" class="scinput" style="width:280px;"/>
                
            </div>
        
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="saveTxType()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="canelTxType()" value="取消" />
            </div>    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            tixingtypeList:[],
            txtypeId:'',
            txtypename:'',
        }
    },
    mounted(){
        this.getTixingType();
    },
    methods:{
        getTixingType(){
            var that = this;
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/kingtime/tixingtype.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.tixingtypeList = res.data.tixingtypeList
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addTxGroup(){
            $(".tip").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip").fadeOut(200);
            })
            this.txtypeId = '';
            this.txtypename = '';
        },
        editTxType(id,name){
            this.txtypeId = id;
            this.txtypename = name;
            $(".tip").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip").fadeOut(200);
            })
        },
        delTxType(id){
            this.txtypeId = id;
        },
        saveTxType(){
            if(this.txtypename.trim() == ''){
                alert("提醒名称不能为空！");
                return;
            }
            if(this.txtypeId == ''){
                var that = this
                let data = {'txtypename':this.txtypename}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/kingtime/inserttixingtype.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("新增成功！");
                        that.getTixingType();
                        that.canelTxType();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
            else{
                var that = this
                let data = {'txtypename':this.txtypename,'id':this.txtypeId}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/kingtime/updtixingtype.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("修改成功！");
                        that.getTixingType();
                        that.canelTxType();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }

        },
        canelTxType(){
            $(".tip").fadeOut(200);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/kingtime/remindtype.vue